<template>
  <div class="main-container min-vh-100">
    <div class="main-wrapper min-vh-100" :class="{blur: displayModal}">
      <div class="close-container">
        <CButton @click="onClose">
          <font-awesome-icon :icon="['fas', 'times']" />
        </CButton>
      </div>
      <CRow v-if="loaded" class="min-vh-100 w-100 m-0">
        <CCol
          v-for="(item, index) in data.content.item"
          :key="index"
          :class="{'character-select-hover': !displayModal}"
          class="col-12 col-xs-6 col-md-3 character-select position-relative"
        >
          <div class="img-container">
            <div class="h-75 d-inline-block position-relative text-center">
              <img
                :src="baseUrl + 'cpr/Image/' + item.image + '.png'"
                class="w-60"
              />
              <!--<img :src="require(`@/assets/images/CPR/E4/${item.image}.png`)" class />-->
            </div>
            <div class="text-center mt-4">
              <p class="text-desc p-2">
                {{ $helpers.translate(item.button.text, 'th') }}
              </p>
            </div>
            <div class="text-center mt-4 mb-4 btn-container">
              <button
                class="btn btn-primary"
                type="button"
                @click.prevent="onDetail(item)"
              >
                ดูรายละเอียด
              </button>
            </div>
          </div>
        </CCol>
      </CRow>
    </div>
    <div id="start-modal" v-if="displayStartModal">
      <div class="text-right">
        <a class="close-preview" @click.prevent="onCloseStart()">
          <span aria-hidden="true">&times;</span>
        </a>
      </div>
      <div id="start-modal-body" class="shadow">
        <img
          :src="baseUrl + 'cpr/Image/' + detail.image + '.png'"
          class="mb-1 thumb"
        />
        <div>
          <p class="desc d-inline-block">{{ desc }}</p>
        </div>
      </div>
      <div class="text-center mt-4">
        <button
          type="button"
          class="btn btn-danger"
          @click.prevent="onStartSimulate()"
        >
          เริ่มจับเวลา
        </button>
      </div>
    </div>
    <div id="desc-modal" v-if="displayModal">
      <div class="row align-items-end">
        <div class="col-12 col-xs-12 col-md-5 text-center">
          <img
            :src="baseUrl + 'cpr/Image/' + detail.image + '.png'"
            class="mb-1 thumb"
          />
          <!--<img :src="require(`@/assets/images/CPR/E4/${detail.image}.png`)" class="mb-1" />-->
        </div>
        <div class="col-12 col-xs-12 col-md-7">
          <div class="body p-4 shadow">
            <h4 class="text-center">PATIENT DETAIL</h4>
            <br />
            <CRow class="mt-2 justify-content-center">
              <CCol class="col-2">เพศ</CCol
              ><CCol class="col-2 text-box">{{ sex }}</CCol
              ><CCol class="col-2"></CCol>
            </CRow>
            <CRow class="mt-2 justify-content-center">
              <CCol class="col-2">อายุ</CCol
              ><CCol class="col-2 text-box">{{ age }}</CCol
              ><CCol class="col-2">{{ ageType }}</CCol>
            </CRow>
            <div class="mt-4">
              <h4 class="text-center">CASE DETAIL</h4>
              <p>{{ $helpers.translate(detail.message, lang) }}</p>
            </div>
          </div>
          <div class="mt-4">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="onCloseModal"
            >
              ย้อนกลับ
            </button>
            <button
              type="button"
              class="btn btn-danger float-right"
              @click.prevent="onStartModal()"
            >
              ทำการช่วยเหลือ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  name: 'SimulationCharacter',
  components: {},
  data() {
    return {
      characters: [],
      data: [],
      lang: 'th',
      detail: [],
      displayModal: false,
      displayStartModal: false,
      loaded: false,
      sex: '',
      age: '',
      ageType: '',
      desc: '',
      close: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      courseCode: '',
    };
  },
  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      // templateContent: 'template/getTemplateContent',
    }),
  },
  watch: {
    getTemplatev3(val) {
      const template = val.templates[0];

      if (!template.enable) {
        this.$router.push({name: 'v4' + template.navigate.close.action});
      } else {
        this.data = template;
        this.close = template.navigate.close.action;
        this.loaded = true;
      }
    },
    // templateContent: function (val) {
    //   if (!val.enable) {
    //     this.$router.push({name: val.navigate.close.action});
    //   } else {
    //     this.data = val;
    //     this.close = val.navigate.close.action;
    //     this.loaded = true;
    //   }
    // },
  },
  mounted() {
    // let body = {};
    // body.code = this.courseCode;
    // body.templateCode = 'CPR-SC01';
    // this.$store.dispatch('template/fetchContent', body);

    const templateCode = 'CPR-SC01';
    this.$store.dispatch('v3/fetchTemplateByCode', templateCode);
  },
  created() {
    this.courseCode = this.$store.getters['necessary/getLerningCourse'];
  },
  methods: {
    onClose() {
      this.$router.push({name: 'v4' + this.close});
    },
    onCloseStart() {
      this.displayStartModal = false;
    },
    onStartModal() {
      this.displayModal = false;
      this.displayStartModal = true;
    },
    onDetail(item) {
      if (this.$helpers.translate(item.button.text, 'en') == 'random') {
        const rannum = Math.ceil(Math.random() * 3);
        item = this.data.content.item[rannum];
      }
      const sex = item.detail.filter(function (desc) {
        if (desc.description == 'sex') {
          return desc;
        }
      });
      const age = item.detail.filter(function (desc) {
        if (desc.description == 'age') {
          return desc;
        }
      });
      const ageType = item.detail.filter(function (desc) {
        if (desc.description == 'ageType') {
          return desc;
        }
      });
      this.sex = sex[0].value;
      this.age = age[0].value;
      this.ageType = ageType[0].value;

      this.templateCode = item.button.action;
      this.desc = this.$helpers.translate(item.button.text, 'th');

      this.detail = item;
      this.displayModal = true;
    },
    onCloseModal() {
      this.detail = [];
      this.displayModal = false;
    },
    onStartSimulate() {
      this.$router.push('/v4/CPR/simulation/' + this.templateCode);
    },
  },
};
</script>
<style scoped>
.w-60 {
  width: 60%;
}
.thumb {
  max-height: 300px;
  max-width: 100%;
  width: auto;
}
@import '../../../assets/scss/CPR/style.scss';
.main-wrapper {
  transition: all 0.5s ease;
}
.character-select .img-container {
  position: relative;
  display: block;
  text-align: center;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  position: absolute;
}
.close-container {
  text-align: center;
  position: absolute;
  top: 15%;
  right: 5%;
  z-index: 9;
  background: transparent
    linear-gradient(139deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(139deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  opacity: 0.8;
  border-radius: 50%;
}
@media (max-width: 768px) {
  .character-select .img-container {
    position: static;
  }
  .character-select .img-container .btn-container {
    visibility: visible !important;
    opacity: 1 !important;
  }
  #desc-modal {
    position: absolute;
    z-index: 999;
    width: 80% !important;
    margin: 0 !important;
    left: 10% !important;
  }
  .character-select {
    margin-top: 50px !important;
  }
}
.text-box {
  background: #ccc;
  text-align: right;
}
.character-select .img-container img {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  transition: all 1s ease;
}
.character-select .img-container .btn-container {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.5s ease;
}
.character-select-hover:hover {
  background: rgb(237, 237, 237);
  background: linear-gradient(
    0deg,
    rgba(237, 237, 237, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}
.character-select-hover:hover .img-container .btn-container {
  visibility: initial;
  opacity: 1;
}
.character-select-hover:hover .img-container img {
  transform: scale(1.1, 1.1);
  -ms-transform: scale(1.1, 1.1);
  -webkit-transform: scale(1.1, 1.1);
}
.text-desc {
  text-align: center;
  background: #fff;
  border-radius: 5px;
  width: 200px;
  max-width: 100%;
  display: inline-block;
}
#start-modal {
  position: absolute;
  z-index: 9999;
  top: 50%;
  left: 50%;
  width: 300px;
  margin-left: -150px;
  margin-top: -150px;
  text-align: center;
}
#start-modal #start-modal-body {
  padding: 10px;
  background: #efefef;
}
#start-modal #start-modal-body .desc {
  background: #fff;
  width: auto;
  padding: 5px;
}
#start-modal #start-modal-body img {
  max-height: 300px;
  max-width: 80%;
  width: auto;
}
#desc-modal {
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 50%;
  width: 50%;
  margin-left: -25%;
  margin-top: -150px;
}
#desc-modal img {
  width: auto;
}
.close-preview {
  cursor: pointer;
  font-size: 36px;
  margin-right: -20px;
}
#desc-modal .body {
  background: #efefef;
  border-radius: 10px;
}
.main-container {
  /* background: transparent linear-gradient(224deg, #ffffff00 0%, #00000038 100%)
    0% 0% no-repeat padding-box; */
  background: #f3f3f3;
}
.shadow {
  box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(200, 54, 97),
    /* right shadow */ 0px 5px 5px 1px rgb(200, 54, 97) !important; /* bottom shadow */
  -webkit-box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(200, 54, 97),
    /* right shadow */ 0px 5px 5px 1px rgb(200, 54, 97) !important; /* bottom shadow */
  -moz-box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(200, 54, 97),
    /* right shadow */ 0px 5px 5px 1px rgb(200, 54, 97) !important; /* bottom shadow */
}
</style>
